// Bootstrap file for Module Federation
// This dynamic import allows webpack to load shared dependencies (React, etc.)
// before the application code runs
import('./bootstrap');
